let baseUrl: string;
if (import.meta.env.MODE !== "production") {
  baseUrl = "http://localhost:4000";
  // baseUrl = "http://quixx.local:4000";
} else {
  baseUrl = "";
}

const config = {
  baseUrl,
};

export default config;
